export const jobStatusNames = {
    New: 'new',
    InProgress: 'in-progress',
    Processed: 'processed',
    Verification: 'verification',
    Done: 'done',
    Rejected: 'rejected',
};

export const STATUSES_REQUIRING_FILES = [jobStatusNames.Processed, jobStatusNames.Verification, jobStatusNames.Done];
